module.exports = __webpack_public_path__ + "static/media/Iftekhar-Riyad.332d805d.jpg";